export default __webpack_public_path__ + "static/media/12-33-22 3.ccf019c8.jpg";